<template>
  <textarea v-model="model" class="textarea" :class="{ isError: error }" v-bind="$attrs" v-on="listeners" />
</template>

<script>
/**
 * テキストエリア
 */
export default {
  name: 'TextArea',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    /** 値 (v-model) */
    value: { type: String, default: null },
    /** エラー表示 */
    error: Boolean,
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        /**
         * 値の変更 (v-model)
         * @event input
         */
        this.$emit('input', value)
      },
    },
    listeners() {
      return {
        ...this.$listeners,
        input: () => {},
        change: e => {
          /**
           * 値変更
           * @event change
           * @type {string}
           */
          this.$emit('change', e.target.value)
        },
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.textarea {
  appearance: none;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  box-sizing: border-box;
  color: var(--text-color);
  display: inline-block;
  font-size: 15px;
  line-height: 23px;
  min-height: 40px;
  outline: 0;
  padding: 18px 16px;
  resize: vertical;
  width: 100%;

  &::placeholder {
    color: var(--gray);
  }

  &:focus {
    border: 1px solid var(--dark-gray);
  }

  &.isError {
    background: var(--light-grayish-red);
    border-color: var(--bright-red-1);
  }
}
</style>
